<template>
    <v-container fluid mt-2>
        <loader :show="$anyLoading()" :message="messageLoader"></loader>
        <v-layout row wrap>
            <v-flex md10 offset-md1 xs12 offset-xs0 mb-2>
                <span class="green--text">Torneos</span>
                <span class="ml-3 mr-3">></span>
                <span>Nuevo Torneo</span>
                <span class="ml-3 mr-3">></span>
                <span>Información General</span>
            </v-flex>
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <h4 class="green--text headline">Información general</h4>
            </v-flex>
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <v-switch
                    v-if="false"
                    color="green"
                    :label="status ? 'Habilitado' : 'Deshabilitado'"
                    v-model="status"
                ></v-switch>
            </v-flex>
            <v-flex md10 offset-md1 xs12 offset-xs0 text-xs-center text-md-left>
                <p>Cuando hayas finalizado de agregar información agrega equipos al torneo</p>
            </v-flex>
            <v-flex md10 offset-md1 xs12 offset-xs0 text-xs-center text-md-right>
                <v-btn v-if="false" color="green" :disabled="this.currentTournament && this.currentTournament.id < 0">Agregar Equipos</v-btn>
            </v-flex>
        </v-layout>

        <v-layout row wrap ref="form">
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <v-card light>
                    <v-card-text>
                        <v-card-title>
                            <h5 class="headline grey--text">Datos del torneo</h5>
                        </v-card-title>
                        <v-container grid-list-md class="px-3">
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-text-field
                                        light
                                        required
                                        label="Nombre"
                                        color="green"
                                        v-model="currentTournament.name"
                                        :rules="rules.required"
                                        ref="name"
                                        :disabled="currentTournament.status === 'finalized'"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3 v-if="editMode">
                                    <v-text-field
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        light
                                        disabled
                                        color="green"
                                        v-model="currentTournament.startDate"
                                        ref="startDate"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3 v-if="!editMode">
                                    <v-menu
                                        lazy
                                        :close-on-content-click="true"
                                        v-model="startDateActivator"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        color="green"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        readonly
                                        light
                                        required
                                        color="green"
                                        :rules="rules.required"
                                        v-model="currentTournament.startDate"
                                        ref="startDate"
                                    ></v-text-field>
                                    <v-date-picker
                                        light
                                        class="green--text"
                                        v-model="currentTournament.startDate"
                                        scrollable
                                        actions
                                        locale="es-MX">
                                        <template slot-scope="{ save, cancel }">
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                            <v-btn flat color="primary" @click="save">OK</v-btn>
                                        </v-card-actions>
                                        </template>
                                    </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 sm6 md3 v-if="editMode">
                                    <v-text-field
                                            label="Fecha de fin"
                                            prepend-icon="event"
                                            disabled
                                            light
                                            color="green"
                                            v-model="currentTournament.endDate"
                                            ref="endDate"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3 v-if="!editMode">
                                    <v-menu
                                        lazy
                                        :close-on-content-click="true"
                                        v-model="endDateActivator"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        class="green--text"
                                        >
                                        <v-text-field
                                            slot="activator"
                                            label="Fecha de fin"
                                            prepend-icon="event"
                                            readonly
                                            light
                                            required
                                            color="green"
                                            :rules="rules.required"
                                            v-model="currentTournament.endDate"
                                            ref="endDate"
                                            :disabled="editMode"
                                        ></v-text-field>
                                        <v-date-picker
                                            light
                                            class="green--text"
                                            v-model="currentTournament.endDate"
                                            scrollable
                                            actions
                                            locale="es-MX">
                                            <template slot-scope="{ save, cancel }">
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                                <v-btn flat color="primary" @click="save">OK</v-btn>
                                            </v-card-actions>
                                            </template>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                    <v-text-field
                                        light
                                        required
                                        label="Periodicidad (Dias)"
                                        color="green"
                                        v-model="currentTournament.periodicity"
                                        :rules="rules.required"
                                        ref="periodicity"
                                        type="number"
                                        :disabled="editMode"
                                        min="0"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                    <v-text-field
                                    xs6
                                        light
                                        label="Numero de jornadas"
                                        color="green"
                                        :rules="rules.required"
                                        type="number"
                                        required
                                        v-model="currentTournament.numberOfSets"
                                        ref="numberOfSets"
                                        :disabled="editMode"
                                        min="0"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                    <v-text-field
                                        light
                                        label="Costo por equipo"
                                        color="green"
                                        :rules="rules.required"
                                        type="number"
                                        required
                                        v-model="currentTournament.price"
                                        ref="price"
                                        min="0"
                                        :disabled="finalized"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                    <v-select
                                        light
                                        :items="['USD', 'MXN']"
                                        label="Moneda"
                                        single-line
                                        bottom
                                        autocomplete
                                        color="green"
                                        v-model="currentTournament.currency"
                                        ref="currency"
                                        :disabled="finalized"
                                        ></v-select>
                                </v-flex>
                                <v-flex xs12 sm3 v-if="this.currentTournament && this.specialTournaments.includes(this.currentTournament.name)">
                                    <v-flex xs12>Acepta registro</v-flex>
                                    <v-flex>
                                        <v-switch
                                            light
                                            color="green"
                                            v-model="currentTournament.registries"
                                            :disabled="editMode"
                                        ></v-switch>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-flex xs12>Aprobación de accesos a equipos</v-flex>
                                    <v-flex>
                                        <v-switch
                                            light
                                            color="green"
                                            v-model="currentTournament.team_approval"
                                        ></v-switch>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-flex xs12>Origen de jugadores</v-flex>
                                    <v-flex>
                                      <v-radio-group light v-model="currentTournament.team_type">
                                        <v-radio
                                          light
                                          :key="0"
                                          :label="`de mi complejo`"
                                          :value="0"
                                        ></v-radio>
                                        <v-radio
                                          light
                                          :key="1"
                                          :label="`de los usuarios`"
                                          :value="1"
                                        ></v-radio>
                                      </v-radio-group>

                                    </v-flex>
                                </v-flex>
                                <v-flex v-if="currentTournament.team_type == 1" xs12 sm3>
                                    <v-flex xs12>Validación de jugadores</v-flex>
                                    <v-flex>
                                      <v-radio-group light v-model="currentTournament.player_validation">
                                        <v-radio
                                          light
                                          :key="0"
                                          :label="`sin validación`"
                                          :value="false"
                                        ></v-radio>
                                        <v-radio
                                          light
                                          :key="1"
                                          :label="`con validación`"
                                          :value="true"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                </v-flex>
                                <v-flex  xs12 sm3>
                                    <v-flex xs12>Tipo de torneo</v-flex>
                                    <v-flex>
                                      <v-radio-group  light v-model="currentTournament.mode">
                                        <v-radio
                                          light
                                          :key="0"
                                          :label="`Normal`"
                                          :value="`normal`"
                                        ></v-radio>
                                        <v-radio
                                          light
                                          :key="1"
                                          :label="`Por grupos`"
                                          :value="`groups`"
                                        ></v-radio>
                                      </v-radio-group>

                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>

            <!-- <v-flex xs10 sm5 offset-xs1 offset-sm1>
                <v-card light height="536px">
                    <v-card-text>
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <p class="headline grey--text">Días de asuetos</p>
                                </v-flex>
                                <v-flex xs6 text-xs-right>
                                    <v-menu
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="addDaysActivator"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        class="green--text"
                                        >
                                        <v-btn
                                            slot="activator"
                                            icon
                                            light>
                                            <v-icon>event</v-icon>
                                        </v-btn>
                                        <v-date-picker
                                            light
                                            class="green--text"
                                            v-model="addDaysDate"
                                            scrollable
                                            actions
                                            locale="es-MX">
                                            <template slot-scope="{ save, cancel }">
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                                </v-card-actions>
                                            </template>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-list light class="days-list">
                                        <v-list-tile avatar v-for="(item, i) in dates" :key="i">
                                            <v-list-tile-content>
                                            <v-list-tile-title v-text="item" :key="i"></v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-btn light flat icon>
                                                    <v-icon light>close</v-icon>
                                                </v-btn>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex> -->

            <!-- <v-flex xs10 sm5 offset-xs1 offset-sm0> -->
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <v-card light>
                    <v-card-text>
                        <v-container>
                            <v-layout row wrap class="rules-container">
                                <v-flex xs12 d-flex>
                                    <p class="headline grey--text">Reglas</p>
                                </v-flex>

                                <!-- <v-flex xs12 d-flex>
                                    <v-flex xs12>Goles</v-flex>
                                    <v-flex>
                                        <v-switch
                                            light
                                            color="green"
                                            v-model="currentTournament.gol"
                                            :disabled="finalized"
                                        ></v-switch>
                                    </v-flex>
                                </v-flex> -->

                                <v-flex md6 xs12 class="rules-container-left">
                                    <v-flex d-flex>
                                        <v-flex xs12>Penales para desempate</v-flex>
                                        <v-flex>
                                            <v-switch
                                                light
                                                color="green"
                                                v-model="currentTournament.penalties"
                                                :disabled="finalized"
                                            ></v-switch>
                                        </v-flex>
                                    </v-flex>

                                    <v-text-field
                                        light
                                        label="Puntos por partido ganado"
                                        type="number"
                                        color="green"
                                        :rules="rules.required"
                                        required
                                        v-model="currentTournament.pointsPerMatchWon"
                                        ref="pointsPerMatchWon"
                                        min="0"
                                        :disabled="finalized">
                                    </v-text-field>

                                    <v-text-field
                                        light
                                        label="Puntos por partido empatado"
                                        type="number"
                                        required
                                        color="green"
                                        :rules="rules.required"
                                        v-model="currentTournament.pointsPerMatchDraw"
                                        ref="pointsPerMatchDraw"
                                        min="0"
                                        :disabled="finalized">
                                    </v-text-field>
                                </v-flex>

                                <v-flex md6 xs12 class="rules-container-right">
                                    <v-text-field
                                        light
                                        label="Partidos de suspensión por tarjeta roja"
                                        type="number"
                                        color="green"
                                        :rules="rules.required"
                                        required
                                        v-model="currentTournament.matchSuspensionsPerRed"
                                        ref="matchSuspensionsPerRed"
                                        min="0"
                                        :disabled="finalized">
                                    </v-text-field>

                                    <v-text-field
                                        light
                                        label="Partidos de suspensión por doble amarilla"
                                        type="number"
                                        color="green"
                                        :rules="rules.required"
                                        required
                                        v-model="currentTournament.matchSuspensionsPerDoubleYellow"
                                        ref="matchSuspensionsPerDoubleYellow"
                                        min="0"
                                        :disabled="finalized">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <br>
        <v-layout row wrap>
            <v-flex md10 offset-md1 xs12 offset-xs0 text-xs-center>
                <p>Cuando hayas finalizado de agregar información agrega equipos al torneo</p>
            </v-flex>
            <v-flex md10 offset-md1 xs12 offset-xs0 text-xs-center text-sm-right>
                <v-btn v-if="false" color="green" :disabled="btnDisabled && this.currentTournament.id < 0">Agregar Equipos</v-btn>
            </v-flex>
            <v-flex md10 offset-md1 xs12 offset-xs0 text-xs-center text-sm-right>
                <v-btn flat color="red">Cancelar</v-btn>
                <v-btn color="green" @click="submit">Guardar</v-btn>
            </v-flex>
        </v-layout>
        <br>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'GeneralInformation',
    data() {
        return {
            specialTournaments: [
                'Alianza Houston',
                'Alianza Dallas',
                'Alianza San Francisco',
                'Alianza Phoenix',
                'Alianza New York',
                'Alianza Los Angeles',
                'Alianza El Paso',
                'Alianza Denver',
                'Alianza Chicago',
                'Alianza Atlanta'
            ],
            messageLoader: 'Cargando Información..',
            hasErrors: false,
            submitted: false,
            rules: {
                required: [
                    val => {
                        let res = ((val === 0 ? '0' : String(val)) || '').length > 0 || 'Este campo es obligatorio'
                        return res
                    }
                ]
            },
            btnDisabled: true,
            status: true,
            addDaysDate: null,
            startDateActivator: false,
            endDateActivator: false,
            addDaysActivator: false,
            dates: [
                '5 de Enero de 2017'
            ],
            editMode: false
        }
    },
    computed: {
        ...mapGetters([
            'currentTournament'
        ]),
        ...mapGetters('loading', [
            'isLoading',
            'anyLoading',
        ]),
        finalized() {
            return this.currentTournament.status === 'finalized'
        },
        routeChanges() {
            if(this.$route.params.tournamentID) this.editMode = true

            return this.$route.params.tournamentID
        },
        form() {
            return {
                name: this.currentTournament.name,
                startDate: this.currentTournament.startDate,
                endDate: this.currentTournament.endDate,
                price: this.currentTournament.price,
                currency: this.currentTournament.currency,
                numberOfSets: this.currentTournament.numberOfSets,
                periodicity: this.currentTournament.periodicity,
                gol: this.currentTournament.gol,
                penalties: this.currentTournament.penalties,
                pointsPerMatchWon: this.currentTournament.pointsPerMatchWon,
                pointsPerMatchDraw: this.currentTournament.pointsPerMatchDraw,
                matchSuspensionsPerRed: this.currentTournament.matchSuspensionsPerRed,
                matchSuspensionsPerDoubleYellow: this.currentTournament.matchSuspensionsPerDoubleYellow,
                status: this.currentTournament.status
            }
        }
    },
    created() {
        if(this.$route.params.tournamentID) {
            this.editMode = true;
            this.findTournament(this.$route.params.tournamentID);
        }
        this.currentTournament.pointsPerMatchWon = this.currentTournament.pointsPerMatchWon || 3;
        this.currentTournament.pointsPerMatchDraw = this.currentTournament.pointsPerMatchDraw || 1;
        this.currentTournament.matchSuspensionsPerRed = this.currentTournament.matchSuspensionsPerRed || 0;
        this.currentTournament.matchSuspensionsPerDoubleYellow = this.currentTournament.matchSuspensionsPerDoubleYellow || 0;
        console.log("CREATE",this.currentTournament)
    },
    watch: {
        routeChanges(val) {
            console.log(val)
        },
        currentTournament(t){
          console.log("watch",this.currentTournament)
        }
    },
    methods: {
        ...mapActions([
            'createTournament',
            'findTournament',
            'updateTournament'
        ]),
        submit() {
            this.hasErrors = false
            this.currentTournament.status = (this.status ? "active" : "pause")

            Object.keys(this.form).forEach(f => {
                if((this.form[f] === null || this.form[f] === "") && f !== 'gol' && f !== 'penalties' && f != 'currency' && this.form[f] !== 0) {
                     this.hasErrors = true
                }

                if(f !== 'gol' && f !== 'penalties' && f != 'currency' && f != 'status' 
                    && (this.editMode && f !== 'startDate' && f !== 'endDate'))
                    this.$refs[f].validate(true)
            })

            if(this.hasErrors) return

            if(!this.editMode) {
                this.messageLoader = 'Registrando Torneo...'
                this.createTournament(this.currentTournament)
            } else {
                this.messageLoader = 'Editando Torneo...'
                this.updateTournament(this.currentTournament)
            }
        }
    }
}
</script>

<style lang="css" scoped>
.card-full-height {
  height: 100% !important;
}
.days-list {
  height: 430px;
  overflow-y: scroll !important;
}

@media screen and (min-width: 960px) {
  .container .rules-container .rules-container-left.flex {
    padding: 0 1.5em 0 0;
  }

  .container .rules-container .rules-container-right.flex {
    padding: 60px 0 0 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/general_information/GeneralInformation.vue